import { Common, ApiBind } from './common.model';

export class EmergencyStop extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'sort' })
  sort: number;

  @ApiBind({ column: 'is_emergency_stop' })
  isEmergencyStop: boolean;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

}
